<template>
  <article v-if="product" class="cn-drivers-card">
    <CdnImg
      v-if="product.variations.length && product.variations[0].images.length"
      :src="product.variations[0].images[0]"
      :width="300"
      :height="300"
    />
    <div class="cn-drivers-card__info">
      <div class="cn-drivers-card__info-line cn-drivers-card__title-line">
        <h2 class="cn-drivers-card__title">
          {{ product.name }}
        </h2>
      </div>
      <div class="cn-drivers-card__info-line">
        <div class="cn-drivers-card__drivers">
          <div class="cn-drivers-card__info-name">
            {{ $t('driver', 2) }}
          </div>
          <div class="cn-drivers-card__info-data">
            <div
              v-if="
                !product.documents['Drivers'] ||
                !product.documents['Drivers'].length
              "
              class="cn-drivers-card__empty"
            >
              {{ $t('no_driver_required') }}
            </div>
            <div v-else class="cn-drivers-card__info-text">
              <div
                v-for="driver in product.documents['Drivers']"
                :key="driver.id"
                class="cn-drivers-card__info-text-item"
              >
                <div>
                  {{ driver.name }}
                </div>
                <div>
                  <a
                    :href="`${config.fullPath}${driver.file}`"
                    target="_blank"
                    class="cn-drivers-card__info-link"
                  >
                    <UiIcon name="download" />
                    <span>{{ $t('download') }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cn-drivers-card__info-line">
        <div class="cn-drivers-card__instructions">
          <div class="cn-drivers-card__info-name">
            {{ $t('instruction', 2) }}
          </div>
          <div class="cn-drivers-card__info-data">
            <div
              v-if="
                !product.documents['Product description'] ||
                !product.documents['Product description'].length
              "
              class="cn-drivers-card__empty"
            >
              {{ $t('no_additional_materials') }}
            </div>
            <div v-else class="cn-drivers-card__info-text">
              <div
                v-for="driver in product.documents['Product description']"
                :key="driver.id"
                class="cn-drivers-card__info-text-item"
              >
                <div>
                  {{ driver.name }}
                </div>
                <div>
                  <a
                    :href="`${config.fullPath}${driver.file}`"
                    target="_blank"
                    class="cn-drivers-card__info-link"
                  >
                    <UiIcon name="download" />
                    <span>{{ $t('download') }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import UiIcon from '@/components/ui/UiIcon';

// TODO: fix type
interface Props {
  product: any;
}

defineProps<Props>();

const config = useRuntimeConfig().public.frontkit;
</script>

<style lang="scss">
.cn-drivers-card {
  --ab-canyon-drivers-card-title-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-drivers-card-color-border: var(--ab-canyon-color-neutral);
  --ab-canyon-drivers-card-info-line-color-border: var(
    --ab-canyon-color-neutral
  );
  --ab-canyon-drivers-card-info-name-color-text: var(
    --ab-canyon-color-neutral-dark
  );
  --ab-canyon-drivers-card-info-color-text: var(--ab-canyon-color-dark);
  --ab-canyon-drivers-card-info-link-color-text: var(--ab-canyon-color-accent);
  --ab-canyon-drivers-card-empty-color-text: var(
    --ab-canyon-color-neutral-dark
  );

  border-color: var(--ab-canyon-drivers-card-color-border);

  border-width: 1px;
  flex-direction: column;
  display: flex;
  @media (min-width: 656px) {
    flex-direction: row;
  }
  &__info {
    padding-top: var(--size-base);
    padding-bottom: var(--size-base);
    align-self: center;
    flex-grow: 1;
    width: 100%;
    @media (min-width: 656px) {
      margin-left: var(--size-base);
    }
    @media (min-width: 1656px) {
      margin-left: var(--size-6xl);
    }

    .cn-drivers-card {
      &__info-line {
        ~ .cn-drivers-card {
          &__info-line {
            border-top-width: 1px;
            border-color: var(--ab-canyon-drivers-card-info-line-color-border);
          }
        }
      }
    }
  }
  &__info-line {
    padding-right: var(--size-base);
    padding-left: var(--size-base);
    padding-top: var(--size-base);
    padding-bottom: var(--size-base);
    @media (min-width: 656px) {
      padding-left: 0px;
    }
    &:not(.cn-drivers-card__title-line) {
      padding-right: 1.5rem;
      @media (min-width: 1280px) {
        padding-right: 0px;
      }
    }
  }
  &__title {
    color: var(--ab-canyon-drivers-card-title-color-text);
    font-weight: 700;
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
  &__drivers {
    row-gap: var(--size-xs);
    column-gap: var(--size-xl);
    justify-content: space-between;
    flex-direction: column;
    display: flex;
    @media (min-width: 1280px) {
      flex-direction: row;
    }
  }
  &__instructions {
    row-gap: var(--size-xs);
    column-gap: var(--size-xl);
    flex-direction: column;
    display: flex;
    @media (min-width: 1280px) {
      flex-direction: row;
    }
  }

  &__info-name {
    color: var(--ab-canyon-drivers-card-info-name-color-text);

    font-size: 0.875rem;
    line-height: 1.25rem;
    @media (min-width: 656px) {
      font-size: 1rem;
      line-height: 1.5rem;
    }
    @media (min-width: 1280px) {
      flex-basis: 150px;
      flex-grow: 1;
    }
  }
  &__info-data {
    max-width: 650px;
    width: 100%;

    @media (min-width: 656px) {
      padding-right: var(--size-5xl);
    }
    @media (min-width: 1656px) {
      padding-right: calc(6 * var(--size-base));
    }
  }
  &__info-link {
    color: var(--ab-canyon-drivers-card-info-link-color-text);
    column-gap: 0.625rem;
    align-items: center;
    display: flex;
    .cn-icon {
      width: var(--size-xl);
      height: var(--size-xl);
    }
  }
  &__info-text {
    color: var(--ab-canyon-drivers-card-info-color-text);
    > :not([hidden]) {
      ~ :not([hidden]) {
        margin-top: var(--size-xs);
      }
    }
  }
  &__info-text-item {
    column-gap: var(--size-xl);
    justify-content: space-between;
    display: flex;
  }
  &__empty {
    color: var(--ab-canyon-drivers-card-empty-color-text);
  }

  > img {
    align-self: center;
    width: 250px;
    height: auto;
    @media (min-width: 1656px) {
      width: 300px;
      height: 300px;
    }
    @media (min-width: 656px) {
      align-self: flex-start;
      width: 250px;
      height: 250px;
    }
  }
}
</style>
